import React, { useState } from 'react'

import { Grid } from '@mui/material'
import {
  AutocompleteInput,
  Create,
  CreateProps,
  NumberInput,
  ReferenceInput,
  SaveButton,
  SimpleForm,
  TextInput,
  TextInputProps,
  Toolbar,
  ToolbarProps,
  required,
  useRefresh,
  useTranslate,
} from 'react-admin'

import { ListHelper } from '../../helpers/List.helper'
import { LXField } from './../../components/LXField'
import genericStyles from './../../generics.module.scss'

export const ArtworksCreate = (props: CreateProps & ArtworksCreateProps): JSX.Element => {
  const { defaultValues } = props
  const translate = useTranslate()
  const refresh = useRefresh()

  const [selectedBeneficiaryId, setSelectedBeneficiaryId] = useState<string>()

  const ArtworkCreateToolbar = (toolbarProps: ToolbarProps) => (
    <Toolbar {...toolbarProps}>
      <SaveButton label="_generics.create" variant="text" disabled={false} />
    </Toolbar>
  )

  return (
    <Create {...props} redirect="show">
      <SimpleForm
        toolbar={<ArtworkCreateToolbar />}
        defaultValues={defaultValues}
        style={{ width: '100%' }}
      >
        <Grid container direction="row" spacing={1}>
          <LXField
            source="name"
            label={translate('_generics.name')}
            elementType={(tiprops: TextInputProps) => (
              <TextInput {...tiprops} fullWidth validate={[required()]} />
            )}
            size={10}
          />
          <LXField size={3}>
            <ReferenceInput
              source="beneficiaryId"
              reference="beneficiaries"
              sort={ListHelper.DEFAULT_SORT}
            >
              <AutocompleteInput
                optionText="name"
                label={translate('_generics.beneficiary')}
                validate={[required()]}
                onChange={id => {
                  setSelectedBeneficiaryId(id)
                  refresh()
                }}
              />
            </ReferenceInput>
          </LXField>
          <LXField size={6}>
            <ReferenceInput
              source="productId"
              reference="products"
              sort={ListHelper.DEFAULT_SORT}
              filter={{ beneficiaryId: selectedBeneficiaryId }}
            >
              <AutocompleteInput optionText="name" label={translate('_generics.product')} />
            </ReferenceInput>
          </LXField>
          <LXField
            source="idNumber"
            label={translate('pages.artworks.idNumber')}
            elementType={NumberInput}
            size={6}
          />
          <LXField label={translate('_generics.productionYear')} size={6}>
            <NumberInput source="productionYear" min={1900} />
          </LXField>
        </Grid>
        <TextInput source="youtubeAssetId" className={genericStyles.hide} />
        <TextInput source="youtubeAssetChannelId" className={genericStyles.hide} />
      </SimpleForm>
    </Create>
  )
}

type ArtworksCreateProps = {
  defaultValues?: object
}
